import './index.css';
import View from '../view';
import Text from '../text';
import useTheme from '../../utilities/hooks/theme';
import React from 'react';

interface Props {
  item: any;
}

const BankDetails = ({ item }: Props) => {
  const { ComponentTheme: theme } = useTheme();
  const headerContainer = {
    backgroundColor: theme.verifyAccountItemHeaderContainer,
    borderTopColor: theme.verifyAccountItemContent
  };

  const headerTitle = {
    color: theme.verifyAccountItemTitle
  };

  const errorTitle = {
    color: theme.error
  };

  const {
    accountNumber = '',
    accountName = '',
    userEnteredAccountName = '',
    ifscCode = '',
    bankName = '',
    comment = '',
    isServerError = false,
    status = ''
  } = item;
  const myName = userEnteredAccountName ? userEnteredAccountName : accountName;

  const reason = isServerError ? 'Something went wrong' : comment;
  return (
    <View className={'bank-details-header-container'} style={headerContainer}>
      <View className={'bank-details-content-container'}>
        <Text className={'bank-details-title'} style={headerTitle}>
          {'A/C Name '}
        </Text>
        <Text style={headerTitle} className={'bank-details-colon'}>
          {' : '}
        </Text>
        <Text className={'bank-details-value'} style={headerTitle}>{`${myName}`}</Text>
      </View>
      <View className={'bank-details-content-container'}>
        <Text className={'bank-details-title'} style={headerTitle}>
          {'A/C No '}
        </Text>
        <Text style={headerTitle} className={'bank-details-colon'}>
          {' : '}
        </Text>
        <Text className={'bank-details-value'} style={headerTitle}>{`${accountNumber}`}</Text>
      </View>
      <View className={'bank-details-content-container'}>
        <Text style={headerTitle} className={'bank-details-title'}>
          {'Bank Name '}
        </Text>
        <Text style={headerTitle} className={'bank-details-colon'}>
          {' : '}
        </Text>
        <Text className={'bank-details-value'} style={headerTitle}>
          {`${bankName}`}
        </Text>
      </View>
      <View className={'bank-details-content-container'}>
        <Text className={'bank-details-title'} style={headerTitle}>
          {'IFSC Code '}
        </Text>
        <Text style={headerTitle} className={'bank-details-colon'}>
          {' : '}
        </Text>
        <Text className={'bank-details-value'} style={headerTitle}>{`${ifscCode}`}</Text>
      </View>
      {comment && status != 'verified' && (
        <View className={'pan-details-content-container'}>
          <Text className={'pan-details-title'} style={headerTitle}>
            {'Reason'}
          </Text>
          <Text className={'pan-details-colon'} style={headerTitle}>
            {':'}
          </Text>
          <Text className={'pan-details-value'} style={errorTitle}>{`${reason}`}</Text>
        </View>
      )}
    </View>
  );
};
export default React.memo(BankDetails);
